// Reconstructed from the supplied production build; original component names were unavailable.
import { useAdminAuth } from "../context/AdminAuthContext.jsx";
import { AdminLayout } from "./AdminLayout.jsx";
import { Navigate } from "../vendor/runtime.js";
const ProtectedRoute = ({ children: e }) => {
  const { adminUser: t, loading: n } = useAdminAuth();
  return n ? (
    <div
      className={
        "min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-purple-50"
      }
    >
      <div className={"p-8 flex flex-col items-center"}>
        <div className={"w-16 h-16 relative"}>
          <div
            className={
              "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
            }
          />
          <div
            className={
              "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-500 animate-pulse opacity-75"
            }
          />
        </div>
      </div>
    </div>
  ) : t ? (
    <AdminLayout>{e}</AdminLayout>
  ) : (
    <Navigate to={"/"} replace={true} />
  );
};
export { ProtectedRoute };
